import { useMutation } from '@tanstack/react-query';
import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { CreateCustomLogParams } from 'clients/CampaignsClient/CampaignsClient.types';

export const useCreateCustomLogMutation = () => {
  return useMutation(async (params: CreateCustomLogParams) => {
    const { data } = await campaignsClient.createCustomLog(params);
    return data;
  });
};
